(function (widgets) {
  var Dropdown = widgets.Widget.extend(
    {
      render: function render() {
        Dropdown.__super__.render.call(this);
        global.removeFocusBorderSelect();

        // Handles "selected" styling of bolder font weight and color
        $(
          '#' +
            this._object.element_id +
            ' select, #' +
            this._object.element_id +
            ' .combobox-input'
        ).change(function () {
          if ($(this).val() !== '') {
            $(this).addClass('selected');
          } else {
            $(this).removeClass('selected');
          }
        });

        // Handle previously selected answers
        if (this._object.answer) {
          $(
            '#' +
              this._object.element_id +
              ' select, #' +
              this._object.element_id +
              ' .combobox-input'
          ).addClass('selected');
        }
        if (this._object.autoadvance) {
          this.$el.change(click_next);
        }

        // Handle "autocomplete" functionality
        if (this._object.autocomplete) this._handleAutocomplete();
      },

      _handleAutocomplete: function _handleAutocomplete() {
        var self = this;
        var $container = $(
          '#' + this._object.element_id + ' .combobox-container'
        );
        var $input = $container.find('.combobox-input');
        var $toggle = $container.find('.combobox-toggle');
        var $options = $container.find('.combobox-options');
        var $hiddenSelect = $container.find('select[aria-hidden="true"]');
        var $noResults = $options.find('.combobox-no-results');
        var allOptions = $options.find('.combobox-option');
        var isOpen = false;
        var selectedIndex = -1;

        // Initialize with previously selected value
        if (this._object.answer) {
          var selectedOption = allOptions.filter(
            '[data-value="' + this._object.answer + '"]'
          );
          if (selectedOption.length) {
            $input.val(selectedOption.text());
            $hiddenSelect.val(this._object.answer);
            selectedOption.attr('aria-selected', 'true').addClass('selected');
          }
        }

        function closeDropdown() {
          isOpen = false;
          $options.hide();
          $input.attr('aria-expanded', 'false');
          selectedIndex = -1;
          allOptions.removeClass('highlighted');
          $toggle.find('i').attr('class', 'ygicon-down');
        }

        function openDropdown() {
          isOpen = true;
          $options.show();
          $input.attr('aria-expanded', 'true');
          $toggle.find('i').attr('class', 'ygicon-up');
        }

        function filterOptions(searchText) {
          $noResults.hide();

          let visibleOptions = [];
          const searchLower = searchText.toLowerCase();

          // Escape search text. Prevents errors with (, ), [, etc.
          const escapedSearch = searchText.replace(
            /[.*+?^${}()|[\]\\]/g,
            '\\$&'
          );
          const isStartMode = self._object.autocomplete_mode === 'start';
          const highlightRegex = new RegExp(
            escapedSearch,
            isStartMode ? 'i' : 'gi'
          );
          const startRegex = isStartMode
            ? new RegExp('^' + escapedSearch, 'i')
            : null;

          allOptions.each(function () {
            const $option = $(this);
            const optionText = $option.text();
            const optionTextLower = optionText.toLowerCase();
            let matches = false;

            // Reset text highlighting
            $option.html(optionText);

            // Look for matches
            matches = isStartMode
              ? startRegex.test(optionTextLower)
              : optionTextLower.includes(searchLower);

            if (matches) {
              // Highlight matching text
              const highlighted = optionText.replace(
                highlightRegex,
                (match) => `<span style="font-weight: normal">${match}</span>`
              );
              $option.html(
                searchLower !== ''
                  ? `<strong>${highlighted}</strong>`
                  : `${highlighted}`
              );

              // Ignores options with "show_on_skip" class.
              // We do not want those options to show until
              // that class is removed by _checkConditionals.
              if (!$option.hasClass('show_on_skip')) $option.show();

              // Add to visible options in the dropdown
              visibleOptions.push($option);
            } else {
              $option.hide();
            }
          });

          if (visibleOptions.length === 0 && searchText) {
            $noResults.show();
          }

          return visibleOptions;
        }

        function selectOption($option) {
          if ($option && $option.length) {
            var value = $option.data('value');
            var text = $option.text();

            $input.val(text);
            $hiddenSelect.val(value);

            allOptions.attr('aria-selected', 'false').removeClass('selected');
            $option.attr('aria-selected', 'true').addClass('selected');

            closeDropdown();
            $input.addClass('selected');
            $input.trigger('change');
          }
        }

        function highlightOption(index, visibleOptions) {
          allOptions.removeClass('highlighted');
          if (index >= 0 && index < visibleOptions.length) {
            $(visibleOptions[index]).addClass('highlighted');
            selectedIndex = index;
          }
        }

        // Input event for filtering
        $input.on('input', function () {
          var searchText = $(this).val();

          // Minimum characters before we start filtering (default: 1)
          if (
            searchText &&
            parseInt(searchText.length) < self._object.autocomplete_chars
          )
            return;

          filterOptions(searchText);
          selectedIndex = -1;

          if (searchText && !isOpen) {
            openDropdown();
          }

          if (!searchText) {
            $hiddenSelect.val('');
            $input.removeClass('selected');
            allOptions.attr('aria-selected', 'false').removeClass('selected');
          }
        });

        // Focus event
        $input.on('focus', function () {
          if (!isOpen) {
            openDropdown();
          }
        });

        // Keyboard navigation
        $input.on('keydown', function (e) {
          var visibleOptions = $options.find('.combobox-option:visible');

          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              if (!isOpen) {
                openDropdown();
                visibleOptions = $options.find('.combobox-option:visible');
              }
              selectedIndex = Math.min(
                selectedIndex + 1,
                visibleOptions.length - 1
              );
              highlightOption(selectedIndex, visibleOptions);
              break;

            case 'ArrowUp':
              e.preventDefault();
              selectedIndex = Math.max(selectedIndex - 1, 0);
              highlightOption(selectedIndex, visibleOptions);
              break;

            case 'Enter':
              e.preventDefault();
              if (isOpen && selectedIndex >= 0) {
                selectOption($(visibleOptions[selectedIndex]));
              }
              break;

            case 'Escape':
              e.preventDefault();
              closeDropdown();
              break;
          }
        });

        // Toggle button click
        $toggle.on('click', function (e) {
          e.preventDefault();
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
          $input.focus();
        });

        // Option click
        $options.on('click', '.combobox-option', function (e) {
          e.preventDefault();
          selectOption($(this));
        });

        // Option hover
        $options.on('mouseenter', '.combobox-option', function () {
          var visibleOptions = $options.find('.combobox-option:visible');
          var index = visibleOptions.index(this);
          highlightOption(index, visibleOptions);
        });

        // Click outside to close
        $(document).on('click', function (e) {
          if (
            !$container.is(e.target) &&
            $container.has(e.target).length === 0
          ) {
            closeDropdown();
          }
        });
      },

      _handleShowOnSkip: function _handleShowOnSkip() {
        var self = this;
        var combobox_opt,
          el,
          elms = self._object.show_on_skip || [];
        for (var i = 0; i < elms.length; i++) {
          el = $(
            '#' +
              self._object.element_id +
              ' select[name="' +
              self._object.input_id +
              '"]'
          ).find('option[value="' + elms[i].code + '"]');

          // Handles the combobox option(s) when autocomplete is enabled.
          if (self._object.autocomplete) {
            combobox_opt = $(
              '#' +
                self._object.element_id +
                ' .combobox-option[data-value="' +
                elms[i].code +
                '"]'
            );
            if (!combobox_opt.hasClass('show_on_skip'))
              combobox_opt.addClass('show_on_skip');

            if (!$('.alert-error').is(':visible')) combobox_opt.hide();
          }

          if (!$('.alert-error').is(':visible')) {
            // Note: using CSS to hide <option> elements in a <select> is not possible in Safari / iOS (by design)
            // We will want to address this issue with those browsers specifically.
            el.hide();
          }
        }

        // interrupt the next click event to check for conditionals
        if (mainNav) {
          mainNav.nextButton.bind(
            'click keypress',
            $.proxy(this, '_checkConditionals')
          );
        }
      },

      _checkConditionals: function _checkConditionals(ev) {
        if (
          ev &&
          ev.type === 'keypress' &&
          ev.key !== ' ' &&
          ev.key !== 'Enter'
        ) {
          return;
        }
        var self = this,
          combobox_opt,
          el,
          elms = self._object.show_on_skip || [];

        var responses = $('#' + self._object.element_id + ' option');
        var answered = _.filter(responses, function (i) {
          return $(i).is(':selected') && $(i).val() !== '';
        });
        var hidden = _.filter(elms, function (i) {
          return (
            $('select[name="' + self._object.input_id + '"]')
              .find('option[value="' + i.code + '"]')
              .css('display') === 'none'
          );
        });

        if (self.isPassed(self, answered, elms, hidden)) {
          return click_next({ key: ev.key, type: ev.type });
        }

        // show the message and extra response option (show_on_skip)
        for (var i = 0; i < elms.length; i++) {
          el = $('select[name="' + self._object.input_id + '"]').find(
            'option[value="' + elms[i].code + '"]'
          );

          // Handles the combobox option(s) when autocomplete is enabled.
          if (self._object.autocomplete) {
            combobox_opt = $(
              '#' +
                self._object.element_id +
                ' .combobox-option[data-value="' +
                elms[i].code +
                '"]'
            );
            combobox_opt.removeClass('show_on_skip');

            if (combobox_opt.css('display') === 'none') combobox_opt.show();
          }

          if (el.css('display') === 'none') {
            el.show();
            if ($('.alert-error').is(':visible')) {
              $('.alert-error').text(self._object.required_text);
            } else {
              $('.alert-error').text(self._object.required_text).show();
            }
            if (!$('.question-open-ended-input').hasClass('has-error')) {
              $('.question-open-ended-input').addClass('has-error');
            }
          }
        }
      },

      destroy: function destroy() {
        Dropdown.__super__.destroy.call(this);
        // Cleanup combobox on destroy
        $(document).off('click');
      },
    },
    {
      types: ['dropdown', 'state', 'country'],
      views: ['dropdown'],
    }
  );

  Dropdown.register();
  widgets.Dropdown = Dropdown;
})((Gryphon.widgets = Gryphon.widgets || {}));
